var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlphabetsort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Arrange-Letter--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Arrange Letter Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 23.248V0.748047",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.75 18.748 4.5 4.5 4.5 -4.5",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 14.248h3.6c0.1471 0 0.2919 0.036 0.4219 0.1049 0.1299 0.0689 0.241 0.1686 0.3235 0.2904 0.0825 0.1217 0.1339 0.2618 0.1497 0.4081 0.0158 0.1462 -0.0045 0.2941 -0.0591 0.4306l-4.372 6.531c-0.0548 0.1367 -0.0752 0.2847 -0.0595 0.431 0.0157 0.1464 0.067 0.2867 0.1495 0.4086 0.0825 0.1219 0.1937 0.2217 0.3238 0.2906 0.13 0.069 0.275 0.105 0.4222 0.1048h3.6",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M20.25 9.748V3c0 -0.59674 -0.2371 -1.16903 -0.659 -1.59099C19.169 0.987053 18.5967 0.75 18 0.75s-1.169 0.237053 -1.591 0.65901c-0.4219 0.42196 -0.659 0.99425 -0.659 1.59099v6.75",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.75 6.74805h4.5",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabetsort);
export default __webpack_public_path__ + "static/media/alphabetsort.a803e591e25fabc7c8f1db23003b1630.svg";
export { ForwardRef as ReactComponent };